import { ChannelStatusAction, TeletriageStatusFragment } from 'shared/types/graphql';

export const HANDOFF_COLOR = '#66DCBF';

export const parseStatusGroupLabel = (status: TeletriageStatusFragment): string => {
  if (status.channelStatusAction === ChannelStatusAction.InactivePermanently) {
    return 'Archived';
  }

  if (status.color === HANDOFF_COLOR) {
    return 'Handoff';
  }

  return 'Active';
};
